import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
/**
 * Adjust the discussion sidebar for the embed view: drop the scrubber, surface
 * a link back to the real discussion with its comment count, and demote the
 * controls so they don't render as the page's primary control.
 *
 * Exported as a pure function so it can be tested against a synthetic ItemList
 * without booting the full DiscussionPage.
 */
export function applyEmbedSidebar(items, discussion) {
  items.remove('scrubber');
  if (discussion) {
    const count = discussion.replyCount() ?? 0;
    items.add('replies', m("h3", null, m("a", {
      href: app.route.discussion(discussion).replace('/embed', '/d'),
      target: "_blank"
    }, count, " comment", count === 1 ? '' : 's')), 100);
  }
  const controls = items.get('controls');
  if (controls?.attrs?.className) {
    controls.attrs.className = controls.attrs.className.replace('App-primaryControl', '');
  }
}
export default function extendDiscussionPage() {
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    // `discussion` is protected on DiscussionPage; access via a cast.
    applyEmbedSidebar(items, this.discussion);
  });
}